import { useExpiredMedicine } from './ContextAPI';
import FormInfo from './FormInfo';
import PrintIndex from './pdf/PrintIndex';

export default function Index() {
    const { showPdf } = useExpiredMedicine();

    return showPdf ? <PrintIndex /> : <FormInfo />;
}
